import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

export class NgLetContext {
  $implicit: any = undefined;
  ngLet: any = undefined;
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ngLet]',
})
export class NgLetDirective implements OnInit {
  private readonly context = new NgLetContext();

  @Input() set ngLet(value: any) {
    this.context.$implicit = this.context.ngLet = value;
  }

  constructor(
    private readonly viewContainerReference: ViewContainerRef,
    private readonly templateReference: TemplateRef<NgLetContext>,
  ) {}

  ngOnInit(): void {
    this.viewContainerReference.createEmbeddedView(
      this.templateReference,
      this.context,
    );
  }
}
